import React, { createElement } from "react";
import styled from "styled-components";
import { DashboardWidget } from "@sanity/dashboard";

const FixedHeight = styled.div<{ $height: number }>`
  height: ${({ $height }) => $height}px;
  overflow: hidden;
`;

/**
 * The dashboard grid never sets `grid-auto-rows`, so `layout.height` only makes
 * a widget span N content-sized rows without capping it: every card grows as
 * tall as its content. Wrapping the widget in a fixed-height box gives the
 * `overflow-y: auto` already present in DashboardWidgetContainer something to
 * work against, so the list scrolls inside the card.
 *
 * Keep `height` >= 420: the container's content area has a 21.5em min-height.
 */
export const withFixedHeight = (
  widget: DashboardWidget,
  height = 480
): DashboardWidget => ({
  ...widget,
  layout: { ...widget.layout, height: undefined },
  component: () => (
    <FixedHeight $height={height}>
      {createElement(widget.component, {})}
    </FixedHeight>
  )
});
